import { TranslationSet } from './en';

// TODO: translate values from English
export const zh: TranslationSet = {
  '(From Now)': '（从现在起）',
  '(From Scheduled)': '（来自预定）',
  '{amount} Off. Expires: {expires}.': '{amount} 关闭。过期：{expires}。',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': '一份详细的报告，显示每项活动以及技术人员或工作人员在每个站点之间和在每个站点之间花费的时间以及在该站点的总时间。',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': '启用检查的服务类型将显示在移动设备上的“检查”列表中。它也用于报告。',
  'Accept Invite': '接受邀请',
  'Add Condition': '添加条件',
  'Add deficiencies to the equipment type': '添加设备类型的缺陷',
  'Add Deficiency': '补充不足',
  'Add Equipment Field': '添加设备字段',
  'Add Equipment Type': '添加设备类型',
  'Add Equipment': '添加设备',
  'Add Floor Plan': '添加平面图',
  'Add history by clicking the plus in the top right or by performing a service.': '通过单击右上角的加号或执行服务来添加历史记录。',
  'Add History': '添加历史记录',
  'Add Model Field': '添加模型字段',
  'Add Model': '添加型号',
  'Add Option': '添加选项',
  'Add Question': '添加问题',
  'Add questions using the plus icon in the top right': '使用右上角的加号图标添加问题',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': '在设置 > 服务月份类别中添加服务月份类别。服务月份允许您在每个地点的选定月份保留不同类型的设备。示例：五月和十月警报，十二月灭火器。',
  'Add Service Month Category': '添加服务月份类别',
  'Add Service Type': '添加服务类型',
  'Add service types in the settings': '在设置中添加服务类型',
  'Add service types using the plus icon in the top right': '使用右上角的加号图标添加服务类型',
  'Add services to the equipment type': '为设备类型添加服务',
  'Add site Field': '添加站点字段',
  'Add Site Override': '添加站点覆盖',
  'Add Site Type': '添加站点类型',
  'Add Site': '添加站点',
  'Add Sites': '添加站点',
  'Add User': '添加用户',
  'Add your own fields in Settings > Custom Fields > Site Fields': '在“设置”>“自定义字段”>“站点字段”中添加您自己的字段',
  'Add': '添加',
  'Adding': '添加',
  'Address': '地址',
  'Advance from Now': '从现在开始前进',
  'Advance from Scheduled': '比预定时间提前',
  'Agree': '同意',
  'All Sites Scheduled!': '所有站点均已安排！',
  'All': '全部',
  'Already have an account? Login': '已经有帐户？登录',
  'An error happened while syncing': '同步时发生错误',
  'April': '四月',
  'August': '八月',
  'Back': '返回',
  'Billing Portal': '计费门户',
  'Building Reports': '建筑报告',
  'Cancel Plan': '取消计划',
  'Cancel Subscription': '取消订阅',
  'Cancel': '取消',
  'Change Model Fields': '更改模型字段',
  'Change Password': '更改密码',
  'Checklist Information': '清单信息',
  'Checklist Question': '清单问题',
  'Checklist': '清单',
  'Choose File': '选择文件',
  'City': '城市',
  'Clear All Data': '清除所有数据',
  'Clear': '清除',
  'Click or tap to add location': '单击或点击以添加位置',
  'Close': '关闭',
  'Company-Wide Reports': '全公司报告',
  'Conditions': '条件',
  'Contact': '联系方式',
  'Copy Barcode': '复制条形码',
  'Could not access': '无法访问',
  'Could not find equipment with the scanned barcode': '找不到带有扫描条形码的设备',
  'Could Not Service': '无法服务',
  'Create': '创建',
  'Creating Your Account': '创建您的帐户',
  'Credentials are not valid': '凭证无效',
  'CSV': 'CSV',
  'Custom Equipment Fields': '���制设备领域',
  'Custom Fields': '自定义字段',
  'Custom Model Fields': '自定义模型字段',
  'Custom site Fields': '自定义站点字段',
  'Date': '日期',
  'Debug': '调试',
  'December': '十二月',
  'Deficiencies': '不足之处',
  'Deficiency Report': '缺陷报告',
  'Deficiency': '缺乏症',
  'Delete Equipment Field?': '删除装备栏？',
  'Delete Equipment Type?': '删除设备类型？',
  'Delete Equipment Type': '删除设备类型',
  'Delete Equipment?': '删除装备？',
  'Delete Equipment': '删除设备',
  'Delete Floor Plan?': '删除平面图？',
  'Delete Model Field?': '删除模型字段？',
  'Delete Model?': '删除模型？',
  'Delete Model': '删除模型',
  'Delete Override': '删除覆盖',
  'Delete Question?': '删除问题？',
  'Delete Question': '删除问题',
  'Delete Record?': '删除记录？',
  'Delete Service Month?': '删除服务月？',
  'Delete Service Type?': '删除服务类型？',
  'Delete Site Field?': '删除站点字段？',
  'Delete Site Type?': '删除站点类型？',
  'Delete Site?': '删除网站？',
  'Delete Site': '删除站点',
  'Delete User?': '删除用户？',
  'Delete User': '删除用户',
  'Delete': '删除',
  'Deleted Equipment Field': '删除设备字段',
  'Deleted Equipment': '删除的装备',
  'Deleted Floor Plan': '已删除平面图',
  'Deleted Model Field': '删除模型字段',
  'Deleted Record': '已删除记录',
  'Deleted Service Month': '删除的服务月份',
  'Deleted Service Type': '删除的服务类型',
  'Deleted Site Field': '已删除站点字段',
  'Deleted Site Type': '已删除的网站类型',
  'Detailed': '详细',
  'Did not want done': '不想完成',
  'Done by others': '��他人完成',
  'Don\'t have an account? Sign Up': '没有帐户？注册',
  'Done': '完成',
  'Edit Dates': '编辑日期',
  'Edit Equipment': '编辑装备',
  'Edit': '编辑',
  'Email is not valid': '电子邮件无效',
  'End Date': '结束日期',
  'Enter your email address': '输入您的电子邮件地址',
  'Equipment already has this barcode': '设备已有此条形码',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': '设备可以是从灭火器到跑步机的任何东西。在设置 > 设备类型中设置设备类型',
  'Equipment Deleted': '设备已删除',
  'Equipment Due Consolidated Report': '设备到期综合报告',
  'Equipment Due Report': '设备到期报告',
  'Equipment Field Information': '设备现场信息',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': '设备字段允许您在设备类型上添加不同的附加字段，例如“电压”或“公里”。',
  'Equipment Fields': '设备领域',
  'Equipment for a site with all scheduled services.': '具有所有预定服务的站点的设备。',
  'Equipment Options': '设备选项',
  'Equipment Report': '设备报告',
  'Equipment Service Report': '设备服务报告',
  'Equipment SKU': '设备库存单位',
  'Equipment Type Deleted': '设备类型已删除',
  'Equipment Type': '设备类型',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': '当选择包含设备的模型时，设备类型可以快速向设备添加检查和服务定义。示例：灭火器、跑步机、卡车',
  'Equipment Types': '设备类型',
  'Equipment': '设备',
  'Export Billing Data': '导出账单数据',
  'Export Data': '导出数据',
  'Export': '出口',
  'Failed to load organization.': '无法加载组织。',
  'Failed to save the organization.': '无法保存组织。',
  'February': '二月',
  'Fill out the options below to prepare your report.': '填写以下选项来准备您的报告。',
  'Filter By': '过滤依据',
  'FlameTask Basic Subscription': 'FlameTask 基本订阅',
  'FlameTask Enterprise Subscription': 'FlameTask 企业订阅',
  'FlameTask Pro Subscription': 'FlameTask 专业版订阅',
  'Floor Plan Location': '平面图 位置',
  'Floor Plan': '平面图',
  'Floor Plans': '平面图',
  'Force Error': '力误差',
  'Forgot Password': '忘记密码',
  'Generate': '生成',
  'Hide "added" history records': '隐藏“已添加”历��记录',
  'Hide Advanced': '隐藏高级',
  'History': '历史',
  'How long a user spent at a site with time between actions.': '用户在网站上花费的时间以及操作之间的时间间隔。',
  'If this email matched an account, a link was sent to reset your password.': '如果此电子邮件与帐户匹配，则会发送一个链接以重置您的密码。',
  'Import Data': '导入数据',
  'Import': '进口',
  'Inspection Due': '检验到期',
  'Inspection Report': '检验报告',
  'Inspection': '检查',
  'Inspections are up to date': '检查是最新的',
  'January': '一月',
  'July': '七月',
  'June': '六月',
  'Leave': '离开',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': '现场所有设备的列表，其中包含显示服务和基于应有服务和/或检查进行过滤的选项。',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': '所有站点及其信息的列表。按状态和服务月份进行筛选的选项，以查找特定月份内提供服务的站点。',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': '现场设备和缺陷列表，按具有开放日期且无关闭日期的缺陷设备进行筛选。',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': '一系列日期之间的设备列表，以及执行服务或检查时提出的问题的答案。',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': '站点的设备列表，其中包含上次检查日期和下次到期服务等重要信息，并以红色突出显示到期检查的设备。',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': '符合型号搜索条件的设备列表。示例：型号信息匹配 6LB ABC DRY 的 5 件设备列表。',
  'Loading Equipment': '装载设备',
  'Loading Models...': '正在加载模型...',
  'Loading Scheduled Services...': '正在加载预定服务...',
  'Loading Scheduled Sites': '加载预定站点',
  'Loading Service Types...': '正在加载服务类型...',
  'Loading Sites': '加载站点',
  'Loading Unscheduled Services...': '正在加载计划外服务...',
  'Loading...': '正在加载...',
  'Location': '地点',
  'Logging in...': '正在登录...',
  'Login Failed': '登录失败',
  'Login': '登录',
  'Logout': '退出',
  'March': '三月',
  'May': '五月',
  'Meter Based Condition': '基于仪表的条件',
  'Model Deleted': '模型已删除',
  'Model Field Information': '模型字段信息',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': '模型字段允许您描述和报告设备，例如“尺寸”、“类型”和“类别”。',
  'Model Fields': '模型字段',
  'Model Information': '型号信息',
  'Model Name': '型号名称',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': '模型允许快速向设备添加信息，例如属于该设备的设备类型/服务。',
  'Models': '型号',
  'Months of History (to start of month)': '历史月份（至月初）',
  'More Details': '更多详情',
  'Name': '名称',
  'Nevermind': '没关系',
  'No Custom Equipment Fields': '无自定义设备字段',
  'No Deficiencies': '没有缺陷',
  'No Equipment Fields': '无设备字段',
  'No Equipment Types': '没有设备类型',
  'No Equipment': '没有设备',
  'No Floor Plans': '没有平面图',
  'No History': '没有历史记录',
  'No Model Fields': '无模型字段',
  'No Models': '没有型号',
  'No Open Deficiencies': '无公开缺陷',
  'No Open or Closed Issues': '没有开放或已关闭的问题',
  'No overrides for this Site': '该网站没有覆盖',
  'No Questions': '没有问题',
  'No Scheduled Services': '无预定服务',
  'No Scheduled Sites': '没有预定站点',
  'No Service Month Categories': '无服务月类别',
  'No Service Types': '无服务类型',
  'No Site Fields': '无站点字段',
  'No Site Types': '没有站点类型',
  'No Sites': '没有站点',
  'No Unscheduled Services': '没有计划外服务',
  'No, Go Back': '不，回去吧',
  'No': '否',
  'Not in at the time of inspection': '检查时未在场',
  'Nothing to Inspect': '没有什么可检查的',
  'Nothing to Service': '没有什么可服务的',
  'November': '十一月',
  'October': '十月',
  'Ok': '好的',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': '单击窗格右上角的加号打开缺陷。问题解决后，单击它并设置关闭日期。',
  'Open a deficiency by tapping Options > Add Deficiency': '通过点击选项 > 添加缺陷来打开缺陷',
  'Open Deficiencies': '开放性缺陷',
  'Open Deficiency': '开放性缺陷',
  'Open in Apple Maps': '在苹果地图中打开',
  'Open in Google Maps': '在 Google 地图中打开',
  'Open Settings': '打开设置',
  'Open': '打开',
  'Optional: Add a deficiency if this option is selected.': '可选：如果选择此选项，则添加缺陷。',
  'Optional: This can be useful to set meter values easily': '可选：这对于轻松设置仪表值很有用',
  'Organization': '组织机构',
  'Outstanding Equipment': '设备精良',
  'PDF': 'PDF',
  'Perform From Now': '从现在开始执行',
  'Perform From Scheduled': '按计划执行',
  'Perform Service From Scheduled': '按计划执行服务',
  'Perform Service': '执行服务',
  'Perform': '执行',
  'Phone Number': '电话号码',
  'Please fill out all fields': '请填写所有字段',
  'Please give a reason': '请给个理由',
  'Please select country first': '请先选择国家',
  'Popup Note': '弹出注释',
  'Preferences': '偏好设置',
  'Preview Details': '预览详情',
  'Profile': '公司简介',
  'Purchase Barcodes': '购买条形码',
  'Question Deleted': '问题已删除',
  'Question Information': '问题信息',
  'Questionnaire Report': '问卷调查报告',
  'Questions': '问题',
  'Range End': '范围结束',
  'Range Start': '范围起始',
  'Reactivate': '重新激活',
  'Remove': '删除',
  'Replace Barcode': '替换条形码',
  'Replace Equipment': '更换设备',
  'Replaced equipment': '更换的设备',
  'Report Date': '报告日期',
  'Reports': '报告',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': '通过在该站点的平面图上绘制设备的位置来节省时间并最大限度地降低风险',
  'Save': '保存',
  'Saving': '节省',
  'Scan barcode to make changes': '扫描条形码进行更改',
  'Scan Barcode': '扫描条码',
  'Scan': '扫描',
  'Schedule': '时间表',
  'Scheduled Event': '预定活��',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': '可以在设置>设备类型中将预定服务定义添加到设备类型中',
  'Scheduled': '预定',
  'See More': '查看更多',
  'Selecting an option will add a history record and remove it from the todo list': '选择一个选项将添加历史记录并将其从待办事项列表中删除',
  'Selective Equipment Report': '选择性装备报告',
  'September': '九月',
  'Service Due': '服务到期',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': '服务月份类别允许您在不同月份保留不同类型的设备。例如，您可以在八月和五月检查灭火器，并在十月检查警报器。',
  'Service Month Categories': '服务月类别',
  'Service Month Category': '服务月类别',
  'Service Month': '服务月',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': '服务月份允许您在每个站点的选定月份保留不同类型的设备。示例：五月和十月警报，十二月灭火器。',
  'Service Months': '服务月数',
  'Service overrides allow you to disable a service or change the frequency for a specific site': '服务覆盖允许您禁用服务或更改特定站点的频率',
  'Service Type Settings': '服务类型设置',
  'Service Type': '服务类型',
  'Service Types': '服务类型',
  'Service': '服务',
  'Services are up to date': '服务是最新的',
  'Services': '服务',
  'Set answer to equipment field': '设置设备字段的答案',
  'Settings': '设置',
  'Show Advanced': '显示高级',
  'Show History Time': '显示历史时间',
  'Show Inspections': '显示检查',
  'Show Questions / Answers': '显示问题/答案',
  'Show Services': '展会服务',
  'Sign Up': '注册',
  'Simulate Scan': '模拟扫描',
  'Site Deleted': '网站已删除',
  'Site Field Information': '站点字段信息',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': '站点字段将允许您在站点中输入附加信息，例如“停车位置”。',
  'Site Fields': '站点字段',
  'Site Information': '站点信息',
  'Site Report': '现场报告',
  'Site Reports': '现场报告',
  'Site Service Override': '站点服务覆盖',
  'Site Service Overrides': '站点服务覆盖',
  'Site Service Settings': '站点服务设置',
  'Site Settings': '站点设置',
  'Site Type': '站点类型',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': '站点类型允许您根据站点更改服务类型。例如，只有每月的客户才会显示每月的检查。',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': '站点类型允许您在不同类型的站点上拥有不同的服务类型。例如，您可能必须在一个地点进行每月检查，而在另一地点仅进行年度检查。',
  'Site Types': '站点类型',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': '站点可以帮助您将设备组织到“办公室”或“仓库”等位置。如果您经营一家服务公司，则可以将您的客户添加为站点。 ',
  'Sites': '站点',
  'Start Date': '开始日期',
  'Start Trial': '开始试用',
  'Status': '状态',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': '站点上的服务摘要，由型号信息分隔。示例 5 使用型号信息进行每月检查 6LB DRY ABC。',
  'Swap Equipment': '交换设备',
  'Swapped equipment': '交换设备',
  'TEST': '测试',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'EMS 计划是针对非营利或公共资助的医疗保健服务的折扣计划。  如果您不符合此条件，请选择其他计划',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': '弹出注释用于提醒您有关位置的重要信息。打开位置屏幕时会出现。',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': '没有未安排的检查、服务或缺陷的场所。',
  'There is no equipment at this site with this search criteria and due inspections': '该站点没有符合此搜索条件和适当检查的设备',
  'There is no equipment at this site with this search criteria and due service': '该网站没有符合此搜索条件和应有服务的设备',
  'This Month': '本月',
  'Time at Site Detailed': '现场时间 详细',
  'Time at Site': '现场时间',
  'Time Based Condition': '基于时间的条件',
  'Today': '今天',
  'Transfer Equipment': '转移设备',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': '可以在设置>设备类型中将非预定服务定义添加到设备类型中',
  'Unscheduled': '计划外',
  'Updated barcode': '更新条形码',
  'Used Equipment SKU': '二手设备 SKU',
  'Used for the billing export for new, swapped and replaced equipment.': '用于新设备、更换设备和更换设备的账单导出。',
  'User Deleted': '用户已删除',
  'User Information': '用户信息',
  'User': '用户',
  'Users': '用户',
  'View on FloorPlan': '查看平面图',
  'View Terms': '查看条款',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': '每当更换设备时，计费导出都会增加此 SKU 下的数量。',
  'Yes, Delete Equipment Field': '是，删除设备字段',
  'Yes, Delete Equipment Type': '是，删除设备类型',
  'Yes, Delete Equipment': '是的，删除设备',
  'Yes, Delete Floor Plan': '是的，删除平面图',
  'Yes, Delete Model Field': '是，删除模型字段',
  'Yes, Delete Model': '是的，删除模型',
  'Yes, Delete Question': '是的，删除问题',
  'Yes, Delete Record': '是的，删除记录',
  'Yes, Delete Service Month': '是，删除服务月份',
  'Yes, Delete Service Type': '是，���除服务类型',
  'Yes, Delete Site Field': '是，删除站点字段',
  'Yes, Delete Site Type': '是，删除站点类型',
  'Yes, Delete Site': '是的，删除网站',
  'Yes, Delete User': '是的，删除用户',
  'Zone': '专区',
  'Customer': '客户',
  'Site': '网站',
  'All Sites': '所有网站',
  'Loading Customers': '加载客户',
  'No Customers': '没有顾客',
  'Add Customer': '添加客户',
  'Customers are groups of sites with billing information.': '客户是具有计费信息的站点组。',
  'Customers': '客户',
  'Customer Information': '客户信息',
  'Delete Customer': '删除客户',
  'Yes, Delete Customer': '是的，删除客户',
  'Delete Customer?': '删除客户？',
  'Customer Deleted': '客户已删除',
  'Create Customer': '创建客户',
  'Assign Existing Customer': '分配现有客户',
  'Edit Customer': '编辑客户',
  'Enter a serial number': '输入序列号',
  'Remove Customer': '删除客户',
  'Find': '查找',
  'Sync Now': '立即同步',
  'Syncing...': '正在同步...',
  'Find equipment by serial number': '按序列号查找设备',
  'Last successful upload was {formattedDate}': '上次成功上传是 {formattedDate}',
  'Up to date as of {formattedDate}': '截至 {formattedDate} 最新',
  'Zones are used to group locations in the location report': '区域用于对位置报告中的位置进行分组',

  'Account Number': '帐号',
  'Add Location Override': '添加位置覆盖',
  'Add New Model': '添加新模型',
  'Add Site Field': '添加站点字段',
  'Address Line 2': '地址行 2',
  'Agree to': '同意',
  'All conditions are true': '所有条件均为真',
  'All Permissions': '所有权限',
  'Allow Text Input': '允许文本输入',
  'An email with the reset password link below has been sent to': '一封包含以下重置密码链接的电子邮件已发送至',
  'An error ocurred while trying to show this page.': '尝试显示此页面时发生错误。',
  'Any condition is true': '任何条件都为真',
  'Background Color': '背景颜色',
  'Billing and customer controls': '计费和客户控制',
  'Building Reports - Safety Scan': '建筑报告 - 安全扫描',
  'Change Another Service': '更改其他服务',
  'Choose Site': '选择站点',
  'click here': '点击这里',
  'Closed Date': '截止日期',
  'Closed Deficiencies': '封闭的缺陷',
  'Company Information': '公司资料',
  'Company Name': '公司名称',
  'Completing Sign Up': '完成注册',
  'Context ID': '上下文ID',
  'Could not find equipment with that barcode': '找不到带有该条形码的设备',
  'Creating invite link...': '正在创建邀请链接...',
  'Current equipment failed to load': '当前设备加载失败',
  'Data File': '数据文件',
  'Data Origin': '数据来源',
  'Date affected by': '受影响日期',
  'Date Completed': '完成日期',
  'Date Started': '开始日期',
  'Delete equipment?': '删除装备？',
  'Dev Environment': '开发环境',
  'Disabled For': '禁用于',
  'Disabled For Location': '位置已禁用',
  'Do not change': '不要改变',
  'Due When': '到期时间',
  'Edit Deficiencies': '编辑缺陷',
  'Edit History': '编辑历史记录',
  'Edit Location': '编辑位置',
  'Edit Schedule': '编辑日程',
  'Edit Service': '编辑服务',
  'Edit Settings': '编辑设置',
  'End Time': '结束时间',
  'Equal to': '等于',
  'Equipment Field': '设备领域',
  'Equipment replaced': '设备更换',
  'Equipment swapped': '设备交换',
  'Example: Broken Handle': '示例：手柄破损',
  'Frequency Type': '频率类型',
  'Generate Reports': '生成报告',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': '首先查看我们在 YouTube 上的教程或在设置中设置您的帐户。',
  'Global Search': '全球搜索',
  'Greater than': '大于',
  'hasn&apos;t accepted their invite yet. You can': '尚未接受他们的邀请。',
  'Include In Reports': '包含在报告中',
  'landscape LetterHead': '风景信笺',
  'Last Date': '最后日期',
  'Last Date Minimum Granularity': '最后日期最小粒度',
  'Last Download': '上次下载',
  'Last Upload': '最后上传',
  'Less than': '少于',
  'Locations can only be added on a desktop browser': '只能在桌面浏览器上添加位置',
  'Looks like you never finished signing up': '您似乎从未完成注册',
  'Metered Condition': '计量条件',
  'Mobile Access': '移动访问',
  'Model Number': '型号',
  'Next Date (Overide)': '下一个日期（覆盖）',
  'No Conditions': '无条件',
  'No Options': '无选项',
  'Not equal to': '不等于',
  'Opened Date': '开业日期',
  'Option Selected': '已选择选项',
  'Perform On Scan': '扫描时执行',
  'Please click the button below to start your free 3 month trial': '请点击下面的按钮开始 3 个月的免费试用',
  'Please review the terms below': '请查看以下条款',
  'Portrait LetterHead': '肖像信头',
  'Postal Code': '邮政编码',
  'Powered By': '供电',
  'Preventive Maintenance': '预防性维护',
  'Profile Image': '个人资料图片',
  'Receive marketing emails': '接收营销电子邮件',
  'Rivison Inc.': '里维森公司',
  'Search Sites...': '搜索网站...',
  'Serial Number': '序列号',
  'Service is Unscheduled': '服务未安排',
  'Service Options': '服务选项',
  'Service or Inspection Due': '服务或检查到期',
  'Show All': '显示全部',
  'Show site selector in top corner': '在顶角显示站点选择器',
  'Sign-Up Failed. Ensure the email is not already is use.': '注册失败。',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': '抱歉，尝试创建邀请链接时出错。',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': '抱歉，您似乎已离线。',
  'Start Time': '开始时间',
  'Successfully updated profile': '已成功更新个人资料',
  'terms and conditions': '条款和条件',
  'Text Input': '文字输入',
  'The date below is used to show history records only.': '以下日期仅用于显示历史记录。',
  'This will just take a moment': '这只需要一点时间',
  'Time Condition': '时间条件',
  'Time Zone': '时区',
  'to generate another invite link.': '生成另一个邀请链接。',
  'Toggle Flashlight': '切换手电筒',
  'Type more characters to narrow the search further': '输入更多字符以进一步缩小搜索范围',
  'Use text answer for': '使用文字答案',
  'Version:': '版本：',
  'View Deficiencies': '查看不足之处',
  'View Equipment': '查看设备',
  'View History': '查看历史记录',
  'View Location': '查看位置',
  'View Schedule': '查看时间表',
  'View Service': '查看服务',
  'View Settings': '查看设置',
  'We hope to see you again.': '我们希望再次见到您。',
  'Web Login': '网页登录',
  'Welcome,': '欢迎，',
  'White Label': '白标',
  'Work Day End Time': '工作日结束时间',
  'Work Day Start Time': '工作日开始时间',
  'You must agree to the terms and conditions': '您必须同意条款和条件',
  'Your Subscription Has Been Canceled': '您的订阅已被取消',
};
